import { reactive } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { ErrorMsgState, useErrorMsg } from '@/model/components/common/message/errorMessage'
import { userEntry } from '@/model/api/user/apiUserEntry'
import { useRouterUtil, RouterTypeData } from '@/model/router/router'
import { UserEntryAuthSendState } from './userEntryAuthSendState'
import { checkFlowRedirect } from './userNoAuth'

/**
 * ログイン認証画面のDOM初期処理を実施する
 * @param state 状態
 * @param store vuex
 * @param router vue router
 */
const initDom = async (state: UserEntryAuthSendState, store: Store<StoreState>, router: Router) => {
  // 初期処理チェック(F5等でusernameが未設定の場合はTOP画面に遷移)
  await checkFlowRedirect(state.username, store, router)
}

/**
 * ワンタイムパスワード発行画面の初期状態を取得する
 * @param props propsデータ
 * @returns reactiveした初期状態
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stateUserEntryAuthSend = (props: any): UserEntryAuthSendState => {
  const state = reactive<UserEntryAuthSendState>({
    loading: false,
    username: props.username,
    type: props.type,
    redirect: props.redirect,
    downloadKey: props.downloadKey,
  })
  return state
}

/**
 * ワンタイムパスワードを発行して画面遷移を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 */
const userEntryAuthSend = async (
  state: UserEntryAuthSendState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState
) => {
  // 一旦メッセージを全て初期化
  error.data.splice(0)
  // ローディングをONにする
  state.loading = true
  // api送信を実施
  const result = await userEntry(store).send(state, error)
  // ローディングをOFFにする
  state.loading = false
  if (result.result) {
    // 正常時の場合は画面遷移を実施する
    const data: RouterTypeData.EntryAuthData = {
      username: state.username,
      type: state.type,
      redirect: state.redirect,
      downloadKey: state.downloadKey,
    }
    useRouterUtil(router).entryAuth(data)
  }
}

export { initDom, stateUserEntryAuthSend, userEntryAuthSend, useErrorMsg }
